const websiteConfigs = {
    baseUrl: 'https://admin.xunlongwang.com/api.php', // 站点域名
    sourceUrl: 'https://admin.xunlongwang.com', // 资源路径
    uploadUrl: '/system/annex/upload', //附近上传路径
    secret: 'BzhjkGuakdzhkGuRSBakdRSBzh',
}

export {
    websiteConfigs
}